import React from 'react';
import { WarehousePageWrapper } from '../../ui-kit';
import { WarehousePermission } from '../../generated/graphql';
import { DeductionListsTable } from './components';

const DeductionListsPage = () => (
    <WarehousePageWrapper
        permissions={{ warehouse: [WarehousePermission.CanViewDeductionList] }}
    >
        <DeductionListsTable />
    </WarehousePageWrapper>
);

export default DeductionListsPage;
